"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelVersionUpload = cancelVersionUpload;
exports.createBatchUpload = createBatchUpload;
exports.getBatchUploadDetail = getBatchUploadDetail;
exports.getBatchUploadList = getBatchUploadList;
exports.getMiniProgramAppList = getMiniProgramAppList;
exports.getVersionDetail = getVersionDetail;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getMiniProgramAppList(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/app/list',
    method: 'GET',
    params: params
  });
}
function createBatchUpload(data) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/batch',
    method: 'POST',
    data: data
  });
}
function getBatchUploadList(params) {
  return (0, _request.default)({
    url: '/admin/companyapp/miniprogram/batch/list',
    method: 'GET',
    params: params
  });
}
function getBatchUploadDetail(batchId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/batch/".concat(batchId),
    method: 'GET'
  });
}
function getVersionDetail(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId),
    method: 'GET'
  });
}
function cancelVersionUpload(versionId) {
  return (0, _request.default)({
    url: "/admin/companyapp/miniprogram/version/".concat(versionId, "/cancel"),
    method: 'POST'
  });
}